import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { LoadedClerk, UseAuthReturn } from "@clerk/react/types";

interface Context {
  auth: UseAuthReturn;
  clerk: LoadedClerk;
}

export const Route = createRootRouteWithContext<Context>()({
  component: RootComponent,
});

function RootComponent() {
  return <Outlet />;
}
